import gql from "graphql-tag";

export const GET_KITS_DATA = gql`
    query getKitsData($iconId: ID!) {
        kitOwners {
            items {
                id
                type
                username
                displayName
            }
        }

        kits {
            items {
                id
                name
                slug
                owner {
                    id
                    username
                }
                isPublic
                isLocked
                description
            }
        }

        currentUser {
            id
            username
            hasSubscription
        }

        kitIdsWithIcon(iconId: $iconId)
    }
`;
